import React, { FC, useState } from "react";
import useInbox from "hooks/useInbox.ts";
import { useUser } from "contexts/userContext/userContext";
import { MailDataI, UserDataT } from "models/models";
import { IconWithTooltip } from "components/Elements/Icon/Icon";
import Image from "components/Elements/Image/Image.tsx";

type RestoreButtonT = {
  data: MailDataI;
  listItemRef: { current: HTMLElement | null };
};

const RestoreButton: FC<RestoreButtonT> = (props) => {
  const { data, listItemRef } = props;
  const [isRestoring, setIsRestoring] = useState(false);
  const { removeMailsAction, removeMailFromState, setMailsCount } = useInbox();
  const { getUserData } = useUser();

  const handleRestoreMail = async () => {
    const response = await removeMailsAction({
      mailsArray: [data?.id],
      mailStatus: data?.mailStatus,
      isUndo: true,
      setLoadingStatus: setIsRestoring,
      userId: getUserData()?.UserId,
    });
    if (response.status === "success") {
      const updatedCounters = calcCounters(data, getUserData());
      setMailsCount(updatedCounters);

      if (listItemRef?.current) {
        listItemRef?.current?.classList?.add("remove-mail-anim");
      }
      setTimeout(() => removeMailFromState(data.id), 300);
    }
  };

  if (data.mailStatus === "removed") return null;

  return isRestoring ? (
    <Image name="preloader" ext="gif" width={30} height={30} />
  ) : (
    <div className="restore-action-icon">
      <IconWithTooltip
        iconProps={{
          name: "newinbox/clock-back",
          large: true,
          gray: true,
          onClick: handleRestoreMail,
        }}
        tooltipProps={{
          tooltipTextKey: "restore-mail-tooltip",
        }}
      />
    </div>
  );
};

const calcCounters = (mailData: MailDataI, currentUser: UserDataT) => {
  const counters = {
    sent: 0,
    received: 0,
    all: 0,
    trash: 0,
    jmail: 0,
    jform: 0,
    jpay: 0,
  };

  counters.all += 1;
  counters.trash -= 1;
  if (mailData.isJMail) {
    counters.jmail -= 1;
  }
  if (mailData.isJForm) {
    counters.jform -= 1;
  }
  if (mailData.isJPay) {
    counters.jpay -= 1;
  }

  // if is inbox
  if (mailData.SenderInfo?.senderEmail === currentUser.UserName) {
    counters.received += 1;
  } else {
    counters.sent += 1;
  }

  return counters;
};

export default RestoreButton;
